import type { TextFieldElementProps } from 'react-hook-form-mui';

import { useAppTranslations } from '@treneo/shared/i18n';

import { TextField } from './text-form-field';

type Props = TextFieldElementProps & {
  name: string;
  label?: string;
};

export const EmailField = ({ name, label, ...props }: Readonly<Props>) => {
  const { t } = useAppTranslations();

  return (
    <TextField {...props} type='email' name={name} label={label ?? t('auth.loginEmail')} required />
  );
};
